let html = `<div class="notice notice--card selector layer--visible layer--render">
    <div class="notice__left">
        <div class="notice__img">
            <img />
        </div>
    </div>
    <div class="notice__body">
        <div class="notice__head">
            <div class="notice__title">{title}</div>
            <div class="notice__time">{time}</div>
        </div>
        
        <div class="notice__descr">{descr}</div>
    </div>
</div>`

export default html